import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["domcontainer", [{
      'show': $props.show
    }, {
      'isMobile': $props.isMobile
    }]]),
    style: _normalizeStyle($data.mainStyle)
  }, [...(_cache[0] || (_cache[0] = [_createElementVNode("div", {
    class: "DOMEditor",
    id: "DOMEditor"
  }, null, -1)]))], 6);
}